import { AbilityBuilder } from '@casl/ability'
// import Roles from '@/utils/role'
import ApiService from '@/services/api.service'

export const setUserAAuthorization = (currentUser) => {
  return AbilityBuilder.define((can, cannot) => {
    let routes = currentUser.routes
    for (const route of routes) {
      if (route.switch === 1) {
        can('switch', 'role')
      }
      let access_rule = route.abilities
      for (const ar in access_rule) {
        let access = access_rule[ar]
        access.map(subject => (
          can('manage', subject)
        ))
      }

      let fieldPermissions = route.fieldPermissions
      for (const action in fieldPermissions) {
        let permissions = fieldPermissions[action]
        for (module of permissions) {
          can(action, module)
        }
      }
    }
  })
}
